<template>
  <div class="corretiva-defeito ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-defeito
            @click="loadChassiFabricante()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3"></div>
    <!--tbl de dados -->
    <b-table
      id="defeito"
      small
      hover
      striped
      sticky-header="550px"
      :items="eixochassis"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            editeixochassis(data.item),
              loadChassiFabricante(),
              loadChassiModelo()
          "
          title="Editar Eixo do chassi"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-defeito
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO CORRETIVA -->
    <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO CORRETIVA -->
    <div>
      <b-modal
        id="modal-multi-defeito"
        hide-footer
        size="lg"
        title="Associar eixo ao chassi"
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-grupo">Chassi Fabricante</label>
              <div>
                <b-form-select
                  v-model="eixochassi.chassifabricante_id"
                  :options="fabricantes"
                  class="mb-3"
                  text-field="fabricante"
                  @change="loadChassiModelo()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-grupo">Chassi modelo</label>
              <div>
                <b-form-select
                  v-model="eixochassi.chassimodelo_id"
                  :options="modelos"
                  class="mb-1"
                  text-field="modelo"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <label for="input-grupo">Eixo</label>
              <div>
                <b-form-select
                  v-model="eixochassi.eixo_id"
                  :options="eixos"
                  class="mb-0"
                  text-field="eixo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <b-form-checkbox
                id="lavador"
                class="mb-3 mt-5"
                v-model="eixochassi.status"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
              >
                Inativo
                <!-- --{{rfilancamento.lavador}} -->
              </b-form-checkbox>
            </b-col>
          </b-row>
          <input id="id-defeito" type="hidden" v-model="eixochassi.id" />

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postEixoChassis()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "ManutencaoSUBgrupo",
  computed: { ...mapState(["user"]) },

  data: function () {
    return {
      carregando: false,
      fabricantes: [],
      modelos: [], // [] lista
      eixochassis: [],
      eixochassi: [],
      eixos: [],

      defeito: {},

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "id", label: "Id", sortable: true },
        { key: "id_empresa", label: "Empresa", sortable: true },
        { key: "chassifabricante", label: "Chassi fabricante", sortable: true },
        { key: "chassimodelo", label: "Chassi modelo", sortable: true },
        { key: "eixo", label: "Eixo", sortable: true },
        {
          key: "status",
          label: "Inativo",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },

        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, eixochassis) => {
            return moment(eixochassis.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        {
          key: "dt_alteracao",
          label: "Data Alteracao",
          sortable: true,
          formatter: (value, key, eixochassis) => {
            return moment(eixochassis.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {},
  methods: {
    ///CHASSI FABRICANTE
    loadChassiFabricante() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/frota/chassifabricante`;
      axios
        .get(url, { params })
        .then((res) => {
          this.fabricantes = res.data.map((gru) => {
            return { ...gru, value: gru.id, fabricante: gru.fabricante };
          });
        })
        .catch(showError);
    },

    ///CHASSI MODELO
    loadChassiModelo() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        chassifabricante_id: `${this.eixochassi.chassifabricante_id}`,
      };
      const url = `${baseApiUrl}/frota/chassimodelo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.modelos = res.data.map((sb) => {
            return { ...sb, value: sb.id, modelo: sb.modelo };
          });
        })
        .catch(showError);
    },

    ///CHASSI MODELO
    loadEixo() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/eixo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.eixos = res.data.map((sb) => {
            return { ...sb, value: sb.id, modelo: sb.eixo };
          });
        })
        .catch(showError);
    },

    ///CHASSI MODELO
    loadEixoChassi() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/eixochassi`;
      axios
        .get(url, { params })
        .then((res) => {
          this.eixochassis = res.data;
        })
        .catch(showError);
    },

    editeixochassis(eixochassi) {
      this.eixochassi = { ...eixochassi };
    },

    postEixoChassis() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        id_funcionario: `${[this.user.id_funcionario]}`,
        chassifabricante_id: `${[this.eixochassi.chassifabricante_id]}`,
        chassimodelo_id: `${[this.eixochassi.chassimodelo_id]}`,
        eixo_id: `${[this.eixochassi.eixo_id]}`,
        status: `${[this.eixochassi.status]}`,
        id: `${[this.eixochassi.id]}`,
      };

      const url = `${baseApiUrl}/pneu/eixochassi`;

      axios
        .post(url, corpo)
        .then(() => {
          this.loadEixoChassi();
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
    },
  },

  mounted() {
    this.loadChassiFabricante();
    this.loadEixo();
    this.loadEixoChassi();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#fabricantes {
  font-size: 0.9em;
  text-align: center;
}
</style>